import { Box } from '@mantine/core'

export default function RightFloating({ children }: { children?: React.ReactNode }) {
  return <Box className={'fixed right-0 top-[30%]'}>{children}</Box>
}
